import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-wrap ga-6" }
const _hoisted_2 = { class: "pt-3" }
const _hoisted_3 = { class: "p-text-lg" }
const _hoisted_4 = { class: "p-text-sm mt-2" }
const _hoisted_5 = {
  class: "p-text-xs mt-2",
  color: "light-grey-1"
}
const _hoisted_6 = {
  key: 0,
  class: "text-center"
}

import { useRouter } from "vue-router"
import { useSettingsStore } from "@/api/store/settings"
import { reactive, shallowRef } from "vue";
import { notificationsService } from '@/api/services/notification';
import { truncateText } from '@/tools/text';
import { formatNotificationDate } from "@/components/Helpers/NotificationHelper";


export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationsView',
  setup(__props) {

const settingsStore = useSettingsStore();

const router = useRouter();

const state = reactive({
  items: [] as any[],
  pagination: {
    meta: {},
    links: [],
    next_page_url: null,
  },
});

const page = shallowRef(1)

const getNotifications = () => {
  notificationsService.index({page: page.value}).then((response) => {
    state.items.push(...response.data)
    state.pagination.meta = response.meta;
    state.pagination.links = response.links;
    state.pagination.next_page_url = response.next_page_url;
  });
}

const markRead = (id: number) => {
  notificationsService.read(id).then((response) => {
    state.items = state.items.map((item) => {
      if (item.id === id) {
        item.read = true;
      }
      return item;
    });
  });
}

const viewNotification = (id: number) => {
  markRead(id);
  router.push({name: 'view-notification', params: {id: id}});
}

const seeMore = () => {
  if (state.pagination.next_page_url) {
    page.value++;
    getNotifications();
  }
}

getNotifications();

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_alert = _resolveComponent("v-alert")!

  return (_openBlock(), _createElementBlock("div", null, [
    (state.items.length > 0)
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 0,
          "no-gutters": ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.items, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id,
                class: "w-100"
              }, [
                _createVNode(_component_v_col, {
                  onClick: ($event: any) => (viewNotification(item.id))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, {
                      class: _normalizeClass([{'sw-notification-not-read': !item.read}, "pa-3 ma-1 sw-notification-read align-center"])
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                          _createElementVNode("div", _hoisted_2, [
                            _createVNode(_component_v_icon, { class: "primary-color" }, {
                              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                _createTextVNode(" fa-wechat ", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_3, _toDisplayString(item.subject), 1),
                            _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(truncateText)(_unref(formatNotificationDate)(item.content), 32)), 1),
                            _createElementVNode("p", _hoisted_5, "From: " + _toDisplayString(item.from), 1)
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["class"])
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]))
            }), 128))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            (state.pagination.next_page_url)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_v_btn, {
                    ripple: false,
                    class: "load-more text-capitalize font-size-12-600",
                    variant: "plain",
                    onClick: seeMore
                  }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createTextVNode(" Load More ", -1)
                    ]))]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (state.items.length == 0)
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 1,
          class: "mt-4 mx-4 mb-3 my-2 py-1",
          "no-gutters": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              class: "my-1 px-10 text-center",
              cols: "12"
            }, {
              default: _withCtx(() => [
                (!_unref(settingsStore).loading)
                  ? (_openBlock(), _createBlock(_component_v_alert, {
                      key: 0,
                      type: "info",
                      variant: "tonal"
                    }, {
                      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                        _createTextVNode("No Notifications", -1)
                      ]))]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})